/**
 * Created by admin on 2018/5/8.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Icon, Modal, Table } from 'antd';
import { ROLES_KEY } from '../../utils/constants';
import './RoleManage.less';
import RoleUserModal from '../../components/account/RoleUserModal';
import RoleEditModal from '../../components/account/RoleEditModal';
import { OperateSpan } from '../../components/Widgets';
import IconTip from '../../components/IconTip';
import _ from 'lodash';

class RoleManage extends PureComponent {
  static defaultProps = {
    roleMenus: [] //所有的角色-菜单信息
  };

  constructor() {
    super();
    this.state = {
      editRole: {},
      showUsers: false,
      showEdit: false
    };
  }

  render() {
    const { roleMenus, dispatch, intl } = this.props;
    const allRoles = _.clone(roleMenus);
    allRoles.splice(
      allRoles.findIndex(role => role.roleKey === ROLES_KEY.normal),
      1
    ); //普通用户是内置角色，不允许编辑也不允许查看
    const { editRole, showUsers, showEdit } = this.state;
    return (
      <div className="role-Management">
        <div className="role-list-head">
          <div className="prefix-title">
            <FormattedMessage id="account_role_list" />
          </div>
          <Button
            type="primary"
            icon="plus"
            onClick={this.showRoleEdit.bind(this, {})}
          >
            <FormattedMessage id="re_add" />
          </Button>
        </div>
        <Table
          columns={[
            {
              title: intl.formatMessage({ id: 'role_manage_role_name' }),
              dataIndex: 'name',
              key: 'name'
            },
            {
              title: intl.formatMessage({ id: 'role_manage_operate' }),
              key: 'action',
              render: (text, record) => {
                return (
                  <div className="role-operate">
                    <OperateSpan
                      onClick={this.toggleRoleUserList.bind(this, record)}
                    >
                      <IconTip
                        title={intl.formatMessage({
                          id: 'role_manage_user_list'
                        })}
                        type="yonghuliebiao"
                      />
                    </OperateSpan>
                    <OperateSpan onClick={this.showRoleEdit.bind(this, record)}>
                      <IconTip
                        title={intl.formatMessage({ id: 'role_manage_edit' })}
                        type="guanliyuan"
                      />
                    </OperateSpan>
                    {this.checkRoleImmutable(record.roleKey) ? null : (
                      <OperateSpan
                        onClick={this.deleteRole.bind(this, record.id)}
                      >
                        <IconTip
                          title={intl.formatMessage({
                            id: 'role_manage_delete'
                          })}
                          type="shanchu"
                        />
                      </OperateSpan>
                    )}
                  </div>
                );
              }
            }
          ]}
          dataSource={allRoles}
          rowKey={record => record.id}
          pagination={
            allRoles.length > 10
              ? {
                  total: allRoles.length,
                  pageSize: 10
                }
              : false
          }
        />
        <RoleUserModal
          visible={showUsers}
          onCancel={this.toggleRoleUserList}
          editRole={editRole}
          dispatch={dispatch}
        />
        <RoleEditModal
          visible={showEdit}
          editRole={editRole}
          dispatch={dispatch}
          onCancel={this.closeRoleEdit}
        />
      </div>
    );
  }

  closeRoleEdit = () => {
    this.setState({ showEdit: false });
  };
  showRoleEdit = editRole => {
    this.setState({ editRole, showEdit: true });
  };

  toggleRoleUserList = editRole => {
    const { showUsers } = this.state;
    if (showUsers) {
      this.setState({ showUsers: false });
    } else {
      this.setState({ editRole, showUsers: true });
      this.props.dispatch({ type: 'role/findRoleUsers', roleId: editRole.id });
    }
  };

  deleteRole = roleId => {
    Modal.confirm({
      content: this.props.intl.formatMessage({
        id: 'role_manage_delete_confirm'
      }),
      onOk: () => {
        const promise = new Promise((resolve, reject) => {
          this.props.dispatch({ type: 'role/delete', roleId, resolve, reject });
        });
        promise.then(
          () => {
            const { roleId: editRoleId } = this.state;
            if (editRoleId === roleId) {
              this.clearState();
            }
          },
          msg => {
            Modal.error({ content: msg });
          }
        );
      }
    });
  };

  clearState = () => {
    this.setState({
      roleId: '',
      roleName: '',
      editMenus: [],
      addedRoleUsers: [],
      delRoleUsers: []
    });
    this.props.dispatch({ type: 'role/update', payload: { roleUsers: [] } });
  };

  /**
   * 检查当前角色是否是内置的角色，只有系统默认角色有roleKey
   * */
  checkRoleImmutable = roleKey => {
    return !!roleKey;
  };
}

const mapStateToProps = state => {
  const { role } = state;
  return { ...role };
};

export default connect(mapStateToProps)(injectIntl(RoleManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/RoleManage.js